import React from "react";
import { Button, Modal } from "react-bootstrap";
import ActionButton from "../button/ActionButton";
import WhiteGreenButton from "../button/whiteGreenButton";
import imageLogo from "../../../media/images/logo.png"
const AcceptRejectModal = ({
  text,
  onClickAccept,
  onClickReject,
  modalStatus,
  yesBtnTxt = 'Yes',
  noBtnTxt = "No",
  loaderActive,
  loadingButtonName,
  isTwoActionsReq = true,
}) => {
  return (
    <Modal className="fade " centered show={modalStatus} style={{}}>
      <div
        className="d-flex align-items-center justify-content-center"

        style={{ padding: "30px", flexDirection: "column" }}>
        <img src={imageLogo} style={{ width: "100px" }} className="mb-4" />
        <div
          className="fs-5"
          style={{
            fontWeight: "600",
            textAlign: "center",
            padding: "20px",
          }}>
          {text}
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: "70%",
          }}>
          {/* <ActionButton
            actionName={"reject"}
            buttonName={"No"}
            onClick={onClickReject}
          />
          <ActionButton
            actionName={"accept"}
            buttonName={"Yes"}
            onClick={onClickAccept}
          /> */}

          {!loaderActive && <>
            {isTwoActionsReq && <WhiteGreenButton
              onClick={onClickReject}
              buttonName={noBtnTxt}
              className={'font-w600 white-background-btn'}
              variant={'primary'}
            />}

            <WhiteGreenButton
              onClick={onClickAccept}
              buttonName={yesBtnTxt}
              className={'font-w600 primary'}
              variant={'primary'}
              style={{
                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                border: 'none',
              }}
            /></>}

          {loaderActive && <WhiteGreenButton

            buttonName={loadingButtonName}
            className={'white-background-btn'}
            variant={'primary'}
          />}
        </div>
      </div>
    </Modal>
  );
};

export default AcceptRejectModal;
